import React, { useState, useRef } from 'react'
import { IconButton } from '../../../ui'

const SESSION_COLOR = '#9b6cc4'

export function StructuredEntryList({ items = [], onChange, maxItems = 10, titleMaxChars = 140, contextMaxChars = 200, readOnly = false }) {
  const [focusedIndex, setFocusedIndex] = useState(null)
  const titleRefs = useRef([])

  function update(index, patch) {
    const next = items.map((item, i) => (i === index ? { ...item, ...patch } : item))
    onChange({ items: next })
  }

  function handleAdd() {
    if (items.length >= maxItems) return
    onChange({ items: [...items, { title: '', context: '' }] })
    setTimeout(() => titleRefs.current[items.length]?.focus(), 0)
  }

  function handleRemove(index) {
    onChange({ items: items.filter((_, i) => i !== index) })
  }

  return (
    <div style={styles.wrap}>
      {items.map((item, index) => {
        const isFocused = focusedIndex === index
        const showContext = isFocused || !!item.context
        return (
          <div
            key={index}
            style={styles.entry}
            onFocus={() => setFocusedIndex(index)}
            onBlur={(e) => {
              if (!e.currentTarget.contains(e.relatedTarget)) setFocusedIndex(null)
            }}
          >
            <div style={styles.entryRow}>
              <input
                ref={(el) => { titleRefs.current[index] = el }}
                style={styles.titleInput}
                value={item.title}
                maxLength={titleMaxChars}
                disabled={readOnly}
                placeholder={readOnly ? '' : 'What was decided…'}
                onChange={(e) => update(index, { title: e.target.value })}
                aria-label={`Decision title ${index + 1}`}
              />
              {!readOnly && (
                <IconButton ariaLabel="Remove entry" onClick={() => handleRemove(index)} tabIndex={-1}>×</IconButton>
              )}
            </div>
            {showContext && (
              <input
                style={styles.contextInput}
                value={item.context}
                maxLength={contextMaxChars}
                disabled={readOnly}
                placeholder={readOnly ? '' : 'Why? (optional)'}
                onChange={(e) => update(index, { context: e.target.value })}
                aria-label={`Decision context ${index + 1}`}
              />
            )}
          </div>
        )
      })}
      {!readOnly && items.length < maxItems && (
        <button style={styles.addBtn} onClick={handleAdd}>+ add decision</button>
      )}
    </div>
  )
}

const styles = {
  wrap: { padding: '10px 12px 12px', display: 'flex', flexDirection: 'column', gap: '6px' },
  entry: {
    background: 'var(--color-background-secondary, #f8f8f6)',
    borderRadius: '5px',
    padding: '7px 9px',
    display: 'flex',
    flexDirection: 'column',
    gap: '3px',
  },
  entryRow: { display: 'flex', alignItems: 'center', gap: '4px' },
  titleInput: {
    flex: 1, border: 'none', outline: 'none', background: 'transparent',
    fontSize: '11px', fontWeight: 500, color: 'var(--text-primary)', lineHeight: '1.5', padding: '1px 0',
  },
  contextInput: {
    width: '100%', border: 'none', outline: 'none', background: 'transparent',
    fontSize: '10px', fontWeight: 400, color: 'var(--text-secondary)', lineHeight: '1.5', padding: '1px 0',
  },
  addBtn: {
    background: 'none', border: 'none', cursor: 'pointer', fontSize: '11px',
    color: SESSION_COLOR, padding: '2px 0', textAlign: 'left', marginTop: '2px',
  },
}
